class FeatureCarousel extends HTMLElement {
  constructor(){
    super();

    this.slides = this.querySelectorAll(".slide");
    this.previews = this.querySelectorAll(".preview-button");
    this.previewTimers = this.querySelectorAll(".preview-timer");
    this.counters = this.querySelectorAll(".slider-counter__button");
    this.counterTimers = this.querySelectorAll(".dot-timer");
    this.nextBtn = this.querySelector("#nextSlide");
    this.prevBtn = this.querySelector("#prevSlide");
    this.slideElements = [this.slides, this.previews, this.counters];
    this.timeIndicators = [...this.previewTimers, ...this.counterTimers];
    this.slideControls = [this.previews, this.counters];
    this.totalSlides = this.slides.length;
    this.currentIndex = 0;
    this.startX = 0;
    this.endX = 0;
    this.autoNextSlide;
    this.slideDuration = this.dataset.seconds * 1000;
    this.play = this.dataset.autoplay === "true" ? true : false; 
    this.themeEditor = window.Shopify && Shopify.designMode ? true : false;
  }

  connectedCallback() {
    this.bindEvents();
    this.setAttributes();
    if(this.play && !this.themeEditor) this.autoPlay();

    /* trigger transition on initial image */
    const firstImage = this.slides[0].querySelector('.slide-media__image');
    if (firstImage) requestAnimationFrame(() => firstImage.classList.add("initial")); 
  }

  bindEvents() {
    this.nextBtn.addEventListener("click", () => this.nextSlide());
    this.prevBtn.addEventListener("click", () => this.prevSlide());
    this.addEventListener("touchstart", (event) => this.handleTouchStart(event));
    this.addEventListener("touchend", (event) => this.handleTouchEnd(event));

    this.slideControls.forEach((control) => {
      control.forEach((btn, index) => {
        btn.addEventListener("click", () => this.updateSlidesAndStopAnimation(index));
      });
    });
  } 

  autoPlay() {
    this.resetAnimations();
    this.autoNextSlide = setInterval(() => this.nextSlide(), this.slideDuration);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateSlides(this.currentIndex);
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateSlides(this.currentIndex);
  }

  updateSlides(slideIndex) {
    this.slides.forEach(slide => slide.classList.remove("initial"));
    
    clearTimeout(this.autoNextSlide);

    this.slideElements.forEach((element) => {
      element.forEach((elem, index) => {
        elem.classList.toggle("active", index === slideIndex);
      });
    });

    this.setAttributes();
    this.currentIndex = slideIndex;

    if(this.play) this.autoPlay();
 }

  handleTouchStart(event) {
    this.startX = event.touches[0].clientX;
  }

  handleTouchEnd(event) {
    this.endX = event.changedTouches[0].clientX;
    this.handleSwipe();
  }

  handleSwipe() {
    if(this.startX - this.endX > 50) {
      this.nextSlide();
    } else if(this.endX - this.startX > 50) {
      this.prevSlide();
    }
  }

  updateSlidesAndStopAnimation(index) {
    this.play = false;
    this.updateSlides(index);
    this.stopAnimations();
  }

  resetAnimations() {
    this.timeIndicators.forEach((timer) => {
      timer.style.animation = "none";
      timer.offsetHeight;
      timer.style.animation = `preview-timer ${this.slideDuration / 1000}s linear forwards`
    });
  }

  stopAnimations(){
    this.timeIndicators.forEach((timer) => timer.style.animation = "none");
    this.classList.add('paused');
  }

  editSlide(slideIndex) {
    this.updateSlidesAndStopAnimation(slideIndex);
    this.slides.forEach((slide, index) => {
      slide.classList.toggle("initial", index === slideIndex);
    });
  }

  setAttributes() {
    this.slides.forEach((slide, index) => {
      slide.setAttribute("aria-hidden", slide.classList.contains("active") ? "false" : "true");
      slide.setAttribute("aria-label", slide.classList.contains("active") ? "Current Slide" : `${index + 1} of ${this.slides.length}`);
    });
    
    this.counters.forEach((counter, index) => {
      counter.setAttribute("aria-label", `${index + 1} of ${this.counters.length}`);
      counter.setAttribute("aria-disabled", counter.classList.contains("active") ? "true" : "false");
    });
  }
}

customElements.define('feature-carousel', FeatureCarousel);



if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:block:select', function (event) {
    const blockSelectedIsSlide = event.target.classList.contains('slide');
    if (!blockSelectedIsSlide) return;

    const blockId = event.detail.blockId;
    const slideElem = document.querySelector(`[data-block-id="${blockId}"]`);
    const slideIndex = parseInt(slideElem.getAttribute('data-block-index'), 10);

    const parentFeatureCarousel = event.target.closest('feature-carousel');
    parentFeatureCarousel.editSlide(slideIndex);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    const blockSelectedIsSlide = event.target.classList.contains('slide');
    if (!blockSelectedIsSlide) return;
  });
}
